<template>
  <PageContainer type="bg2">
    <el-row class="product-search-bar" :gutter="24">
      <el-col :xs="24" :md="16" :lg="20" style="padding-bottom: 14px">
        <el-input v-model="productName" placeholder="商品名稱" @keyup.enter.native="handleSearch(productName)" />
      </el-col>
      <el-col class="button-group" :xs="24" :md="8" :lg="4">
        <el-button trigger="click" @click="handleSearch(productName)"> 搜尋 </el-button>
      </el-col>
    </el-row>
    <el-row class="product-list" :gutter="24">
      <el-col :xs="24" :md="4">
        <ul class="product-menu">
          <li :class="{'product-menu--actived': selectMainCategory.name === '全部'}" @click="handleSelectMainCategory(defaultSelect)">全部</li>
          <li v-for="item in firstCategory" :key="item.name" :class="{'product-menu--actived': selectMainCategory.name === item.name} " @click="handleSelectMainCategory(item)">
            {{ item.name }}
          </li>
        </ul>
      </el-col>
      <el-col :md="20" :xs="24">
        <ul class="product-sub-menu">
          <li v-for="item in subCategory" :key="item.name" :class="{'product-sub-menu--actived': selectSubCategory.name === item.name} " @click="handleSelectSubCategory(item)">
            {{ item.name }}
          </li>
        </ul>
        <ul class="product-sub-menu">
          <li v-for="item in thirdCategory" :key="item.name" :class="{'product-sub-menu--actived': selectThirdCategory.name === item.name} " @click="handleSelectThirdCategory(item)">
            {{ item.name }}
          </li>
        </ul>
        <div class="products__container">
          <el-row v-if="products.length === 0">
            此分類/搜尋目前沒有商品
          </el-row>
          <el-row v-else :gutter="24">
            <el-col v-for="product in products" :key="product.id" :xs="24" :md="12" :lg="8">
              <Product :data-source="product.item" @onClick="handleRedirect(product.item)" />
            </el-col>
          </el-row>
        </div>
        <el-row type="flex" justify="center">
          <el-pagination
            layout="prev, pager, next"
            :page-size="pages.limit"
            :total="pages.total"
            @current-change="handleChangePage"
          />
        </el-row>
      </el-col>

    </el-row>
  </PageContainer>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import api from '@/api'
import Product from '../components/Product.vue'
import PageContainer from '@/components/PageContainer.vue'

export default {
  components: {
    Product,
    PageContainer
  },
  data() {
    return {
      defaultSelect: { name: '全部' },
      selectMainCategory: { name: '全部' },
      selectSubCategory: { name: '全部' },
      selectThirdCategory: {},
      products: [],
      pages: {
        total: 0,
        page: 1,
        limit: 12
      },
      intervalId: null,
      productName: ''
    }
  },
  computed: {
    ...mapGetters(['firstCategory']),
    ...mapGetters(['category']),
    subCategory() {
      if (this.selectMainCategory.name === '全部') {
        return []
      } else {
        return [this.defaultSelect, ...this.category.filter(item => item.parentCategoryId === this.selectMainCategory.id)]
      }
    },
    thirdCategory() {
      if (this.selectSubCategory.name === '全部') {
        return []
      } else {
        return [this.defaultSelect, ...this.category.find(item => item.name === this.selectSubCategory.name).subcategorySet]
      }
    }
  },
  watch: {
    'selectSubCategory.name': {
      immediate: true,
      deep: true,
      handler(value, oldValue) {
        if (value !== oldValue) {
          this.selectThirdCategory = this.thirdCategory[0] ? this.thirdCategory[0] : {}
        }
      }
    }
  },
  mounted() {
    this.handleGetProduct()
    if (this.firstCategory.length === 0) {
      this.getFirstCategory()
    }
    if (this.category.length === 0) {
      this.getCategory()
    }
  },
  methods: {
    ...mapActions(['getFirstCategory']),
    ...mapActions(['getCategory']),
    handleSearch(productName) {
      this.productName = productName
      this.handleGetProduct()
    },
    handleSelectMainCategory(mainCategory) {
      this.selectMainCategory = mainCategory
      this.selectSubCategory = this.defaultSelect
      this.handleGetProduct()
    },
    handleSelectSubCategory(subCategory) {
      this.selectSubCategory = subCategory
      this.selectThirdCategory = this.defaultSelect
      this.handleGetProduct()
    },
    handleSelectThirdCategory(subCategory) {
      this.selectThirdCategory = subCategory
      this.handleGetProduct()
    },
    handleChangePage(page) {
      this.pages.page = page
      this.handleGetProduct()
    },
    handleScrollTop() {
      this.intervalId = setInterval(() => {
        if (window.pageYOffset === 0) {
          clearInterval(this.intervalId)
        }
        window.scroll(0, window.pageYOffset - 50)
      }, 20)
    },
    async handleGetProduct() {
      try {
        const params = {
          page: this.pages.page,
          limit: this.pages.limit
        }
        if (this.selectMainCategory.id) {
          params.parentCategoryId = this.selectMainCategory.id
        }
        if (this.selectSubCategory.id) {
          params.categoryId = this.selectSubCategory.id
        }
        if (this.selectThirdCategory.id) {
          params.subcategoryId = this.selectThirdCategory.id
        }

        if (this.productName) {
          params.title = this.productName
        }

        const { data, success } = await api.product.products(params)
        if (success) {
          this.products = data.records
          this.pages.total = data.total
          // this.handleScrollTop()
        }
      } catch (err) {
        console.log(err)
      }
    },
    handleRedirect({ id }) {
      this.$router.push({ name: 'ProductDetail', params: { productId: id }})
    }
  }
}
</script>

<style lang="scss" scoped>
.product-search-bar {
  margin-bottom: 20px;
}
.product-list {
  width: 100%;
}
.products {
  text-align: center;
  img {
    width: 100%;
    margin-bottom: 40px;
    border: 1px solid #000;
  }
  @media screen and (max-width: 576px) {
    h2 {
      font-size: 24px;
    }
  }

  &__container {
    margin-bottom: 20px;
  }
}

.product-menu {
  text-align: left;
  display: flex;
  flex-direction: row;
  overflow-y: scroll;

  > li {
    padding: 0 12px;
    font-size: 16px;
    cursor: pointer;
    margin-bottom: 12px;
    font-weight: 500;
    flex-shrink: 0;
    border-radius: 24px;
    &.product-menu--actived {
      color: #fff;
      background-color: $mainPurple;
    }
  }

  @include minWidth992 {
    flex-direction: column;
  }

}

.product-sub-menu {
  text-align: left;
  display: flex;
  flex-direction: row;
  padding: 0;
  align-items: center;
  //height: 40px;
  overflow-y: auto;

  > li {
    padding: 0 12px;
    font-size: 16px;
    cursor: pointer;
    margin-bottom: 12px;
    font-weight: 500;
    flex-shrink: 0;
    border-radius: 24px;
  }

  &--actived {
    color: #fff;
    background-color: $mainPurple;
  }
}

::v-deep.el-pager li {
  font-size: 20px;
}

::v-deep.el-pagination   {
  .btn-prev, .btn-next {
    font-size: 18px;
  }
}

::v-deep.el-pager li, ::v-deep.el-pagination button:disabled, ::v-deep.el-pagination .btn-next, ::v-deep.el-pagination .btn-prev {
  background-color: transparent;
}
::v-deep.el-pager li.active, ::v-deep.el-pager li:hover {
  color: $mainPurple;
}

.el-button {
  background-color: #264682;
  color: #fff;
  border: 0;
  width: 100%;
  //max-width:120px;

  &:hover {
    background-color:  #6AF3EA;
  }
}
</style>
